// import React, { useEffect, useRef, useState } from 'react';
// import { Col, Input, Radio, Row, Select } from 'antd';
// import axios from '../../utils/axios';
// import FilePreviewUploader from '../FilePreviewUploader';
// import FAQ from './FAQ';
// import Editor from '../Editor';

// export default function Details({ Form, getFieldValue, setFieldValue, fileList, setFileList }) {
// 	const editor = useRef();
// 	const [isEventTypeLoading, setEventTypeLoading] = useState(true);
// 	const [eventTypes, setEventTypes] = useState([]);
// 	const getEventTypes = () => {
// 		axios
// 			.get(`/event-type`)
// 			.then((result) => {
// 				if (Array.isArray(result.data.data) && result.data.data.length) {
// 					setEventTypes(result.data.data);
// 				}
// 			})
// 			.catch(() => {})
// 			.finally(() => {
// 				setEventTypeLoading(false);
// 			});
// 	};

// 	const onNoteTemplateChange = (option, field) => {
// 		const existingData = structuredClone(getFieldValue(field));
// 		const tempOption = structuredClone(option);
// 		if (field === 'otherDetails' || field === 'highlights') {
// 			if (tempOption?.templateRichText?.text) {
// 				let ops = [];
// 				if (existingData?.delta) {
// 					if (typeof existingData?.delta === 'string') {
// 						existingData.delta = JSON.parse(typeof existingData.delta);
// 					}
// 					ops = [...existingData.delta.ops, JSON.parse(tempOption.templateRichText.delta).ops];
// 				} else {
// 					ops = JSON.parse(tempOption.templateRichText.delta).ops;
// 				}
// 				setFieldValue(field, { delta: { ops } });
// 			}
// 		} else if (option.templateText) {
// 			setFieldValue(field, existingData ? `${existingData}\n${option.templateText}` : option.templateText);
// 		}
// 	};
// 	useEffect(() => {
// 		getEventTypes();
// 	}, []);
// 	return (
// 		<Row gutter={[16, 0]}>
// 			<Col sm={24} md={12}>
// 				<Form.Item
// 					label='Title'
// 					name='title'
// 					rules={[
// 						{
// 							required: true,
// 							message: 'Title is required',
// 						},
// 					]}
// 				>
// 					<Input placeholder='Kashmir Tour' autoFocus />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={4}>
// 				<Form.Item label='Tours/Trek?' name='isTrekOrTour'>
// 					<Radio.Group>
// 						<Radio value='Trek'>Trek</Radio>
// 						<Radio value='Tour'>Tour</Radio>
// 					</Radio.Group>
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={4}>
// 				<Form.Item label='Event type' name='eventType'>
// 					<Select allowClear showArrow mode='multiple' style={{ width: '100%' }} placeholder='Group Tour, Sahyadri Trek' fieldNames={{ label: 'eventType', value: '_id' }} loading={isEventTypeLoading} options={eventTypes} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={4}>
// 				<Form.Item label='Difficulty level' name='difficultyLevel'>
// 					<Select
// 						allowClear
// 						showArrow
// 						style={{ width: '100%' }}
// 						placeholder='Easy, Medium'
// 						options={[
// 							{
// 								label: 'Easy',
// 								value: 'Easy',
// 							},
// 							{
// 								label: 'Medium',
// 								value: 'Medium',
// 							},
// 							{
// 								label: 'Hard',
// 								value: 'Hard',
// 							},
// 						]}
// 					/>
// 				</Form.Item>
// 			</Col>

// 			<Col sm={24} md={4}>
// 				<Form.Item
// 					label={
// 						<span>
// 							Days&nbsp;
// 							<span style={{ fontSize: '12px', color: '#888' }}>(Total no. of days for tour/trek)</span>
// 						</span>
// 					}
// 					name='days'
// 				>
// 					<Input type='number' placeholder='3' min={1} />
// 				</Form.Item>
// 			</Col>

// 			<Col sm={24} md={4}>
// 				<Form.Item
// 					label={
// 						<span>
// 							Nights&nbsp;
// 							<span style={{ fontSize: '12px', color: '#888' }}>(Total nights including stay/camp)</span>
// 						</span>
// 					}
// 					name='nights'
// 				>
// 					<Input type='number' placeholder='2' min={0} />
// 				</Form.Item>
// 			</Col>

// 			<Col sm={24} md={12}>
// 				<Form.Item label='Description' name='description'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				{/* <NoteTemplateSelector fieldLabel='Highlights' fieldName='highlights' onChange={onNoteTemplateChange} />
// 				<Form.Item name='highlights'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item> */}
// 				{/* <Form.Item label='Highlights' name='highlights'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item> */}
// 				<Form.Item label='Highlights' name='highlights'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Includes' fieldName='includes' onChange={onNoteTemplateChange} />
// 				<Form.Item name='includes'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Excludes' fieldName='excludes' onChange={onNoteTemplateChange} />
// 				<Form.Item name='excludes'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Other Details' fieldName='otherDetails' onChange={onNoteTemplateChange} />
// 				<Form.Item name='otherDetails'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<Form.Item label='Photos' name='media'>
// 					<FilePreviewUploader Form={Form} maxItems={10} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={24}>
// 				<FAQ Form={Form} />
// 			</Col>
// 		</Row>
// 	);
// }

// function NoteTemplateSelector({ fieldLabel, fieldName, onChange }) {
// 	const [isNoteTemplatesLoading, setNoteTemplatesLoading] = useState(true);
// 	const [noteTemplates, setNoteTemplates] = useState([]);

// 	const getNotesTemplates = () => {
// 		axios
// 			.get(`/note-template`)
// 			.then((result) => {
// 				if (Array.isArray(result.data.data) && result.data.data.length) {
// 					setNoteTemplates(result.data.data);
// 				}
// 			})
// 			.catch(() => {})
// 			.finally(() => {
// 				setNoteTemplatesLoading(false);
// 			});
// 	};

// 	useEffect(() => {
// 		getNotesTemplates();
// 	}, []);

// 	return (
// 		<Row align='bottom' style={{ marginBottom: 10 }}>
// 			<Col sm={12} md={12}>
// 				{fieldLabel}
// 			</Col>
// 			<Col sm={12} md={12}>
// 				<Select
// 					placeholder='Select from Note Templates'
// 					style={{ width: '100%' }}
// 					fieldNames={{ label: 'templateName', value: '_id' }}
// 					loading={isNoteTemplatesLoading}
// 					options={noteTemplates}
// 					onChange={(value, option) => {
// 						onChange(option, fieldName);
// 					}}
// 				/>
// 			</Col>
// 		</Row>
// 	);
// }

// import React, { useEffect, useRef, useState } from 'react';
// import { Col, Input, Radio, Row, Select } from 'antd';
// import axios from '../../utils/axios';
// import FilePreviewUploader from '../FilePreviewUploader';
// import FAQ from './FAQ';
// import Editor from '../Editor';

// export default function Details({ Form, getFieldValue, setFieldValue, fileList, setFileList }) {
// 	const editor = useRef();
// 	const [isEventTypeLoading, setEventTypeLoading] = useState(true);
// 	const [eventTypes, setEventTypes] = useState([]);
// 	const getEventTypes = () => {
// 		axios
// 			.get(`/event-type`)
// 			.then((result) => {
// 				if (Array.isArray(result.data.data) && result.data.data.length) {
// 					setEventTypes(result.data.data);
// 				}
// 			})
// 			.catch(() => {})
// 			.finally(() => {
// 				setEventTypeLoading(false);
// 			});
// 	};

// 	// const onNoteTemplateChange = (option, field) => {
// 	// 	const existingData = structuredClone(getFieldValue(field));
// 	// 	const tempOption = structuredClone(option);
// 	// 	if (field === 'otherDetails' || field === 'highlights') {
// 	// 		if (tempOption?.templateRichText?.text) {
// 	// 			let ops = [];
// 	// 			if (existingData?.delta) {
// 	// 				if (typeof existingData?.delta === 'string') {
// 	// 					existingData.delta = JSON.parse(typeof existingData.delta);
// 	// 				}
// 	// 				ops = [...existingData.delta.ops, JSON.parse(tempOption.templateRichText.delta).ops];
// 	// 			} else {
// 	// 				ops = JSON.parse(tempOption.templateRichText.delta).ops;
// 	// 			}
// 	// 			setFieldValue(field, { delta: { ops } });
// 	// 		}
// 	// 	} else if (option.templateText) {
// 	// 		setFieldValue(field, existingData ? `${existingData}\n${option.templateText}` : option.templateText);
// 	// 	}
// 	// };

// 	const onNoteTemplateChange = (option, field) => {
// 		const existingData = structuredClone(getFieldValue(field));
// 		const tempOption = structuredClone(option);

// 		if (['otherDetails', 'highlights', 'cancellationPolicy'].includes(field)) {
// 			if (tempOption?.templateRichText?.text) {
// 				let ops = [];
// 				if (existingData?.delta) {
// 					if (typeof existingData?.delta === 'string') {
// 						existingData.delta = JSON.parse(existingData.delta);
// 					}
// 					ops = [
// 						...existingData.delta.ops,
// 						...JSON.parse(tempOption.templateRichText.delta).ops
// 					];
// 				} else {
// 					ops = JSON.parse(tempOption.templateRichText.delta).ops;
// 				}

// 				// ✅ MongoDB ला जाण्याआधी pure string बनव
// 				setFieldValue(field, {
// 					delta: JSON.stringify({ ops }),
// 					html: tempOption?.templateRichText?.html || '',
// 					text: tempOption?.templateRichText?.text || ''
// 				});
// 			}
// 		} else if (option.templateText) {
// 			setFieldValue(
// 				field,
// 				existingData
// 					? `${existingData}\n${option.templateText}`
// 					: option.templateText
// 			);
// 		}
// 	};

// 	useEffect(() => {
// 		getEventTypes();
// 	}, []);
// 	return (
// 		<Row gutter={[16, 0]}>
// 			<Col sm={24} md={12}>
// 				<Form.Item
// 					label='Title'
// 					name='title'
// 					rules={[
// 						{
// 							required: true,
// 							message: 'Title is required',
// 						},
// 					]}
// 				>
// 					<Input placeholder='Kashmir Tour' autoFocus />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={4}>
// 				<Form.Item label='Tours/Trek?' name='isTrekOrTour'>
// 					<Radio.Group>
// 						<Radio value='Trek'>Trek</Radio>
// 						<Radio value='Tour'>Tour</Radio>
// 					</Radio.Group>
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={4}>
// 				<Form.Item label='Event type' name='eventType'>
// 					<Select allowClear showArrow mode='multiple' style={{ width: '100%' }} placeholder='Group Tour, Sahyadri Trek' fieldNames={{ label: 'eventType', value: '_id' }} loading={isEventTypeLoading} options={eventTypes} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={4}>
// 				<Form.Item label='Difficulty level' name='difficultyLevel'>
// 					<Select
// 						allowClear
// 						showArrow
// 						style={{ width: '100%' }}
// 						placeholder='Easy, Medium'
// 						options={[
// 							{
// 								label: 'Easy',
// 								value: 'Easy',
// 							},
// 							{
// 								label: 'Medium',
// 								value: 'Medium',
// 							},
// 							{
// 								label: 'Hard',
// 								value: 'Hard',
// 							},
// 						]}
// 					/>
// 				</Form.Item>
// 			</Col>

// 			<Col sm={24} md={4}>
// 				<Form.Item
// 					label={
// 						<span>
// 							Days&nbsp;
// 							<span style={{ fontSize: '12px', color: '#888' }}>(Total no. of days for tour/trek)</span>
// 						</span>
// 					}
// 					name='days'
// 				>
// 					<Input type='number' placeholder='3' min={1} />
// 				</Form.Item>
// 			</Col>

// 			<Col sm={24} md={4}>
// 				<Form.Item
// 					label={
// 						<span>
// 							Nights&nbsp;
// 							<span style={{ fontSize: '12px', color: '#888' }}>(Total nights including stay/camp)</span>
// 						</span>
// 					}
// 					name='nights'
// 				>
// 					<Input type='number' placeholder='2' min={0} />
// 				</Form.Item>
// 			</Col>

// 			<Col sm={24} md={12}>
// 				<Form.Item label='Description' name='description'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				{/* <NoteTemplateSelector fieldLabel='Highlights' fieldName='highlights' onChange={onNoteTemplateChange} />
// 				<Form.Item name='highlights'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item> */}
// 				{/* <Form.Item label='Highlights' name='highlights'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item> */}
// 				<Form.Item label='Highlights' name='highlights'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Includes' fieldName='includes' onChange={onNoteTemplateChange} />
// 				<Form.Item name='includes'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Excludes' fieldName='excludes' onChange={onNoteTemplateChange} />
// 				<Form.Item name='excludes'>
// 					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Other Details' fieldName='otherDetails' onChange={onNoteTemplateChange} />
// 				<Form.Item name='otherDetails'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<NoteTemplateSelector fieldLabel='Cancellation Policy' fieldName='cancellationPolicy' onChange={onNoteTemplateChange} />
// 				<Form.Item name='cancellationPolicy'>
// 					<Editor ref={editor} Form={Form} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={12}>
// 				<Form.Item label='Photos' name='media'>
// 					<FilePreviewUploader Form={Form} maxItems={10} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
// 				</Form.Item>
// 			</Col>
// 			<Col sm={24} md={24}>
// 				<FAQ Form={Form} />
// 			</Col>
// 		</Row>
// 	);
// }

// function NoteTemplateSelector({ fieldLabel, fieldName, onChange }) {
// 	const [isNoteTemplatesLoading, setNoteTemplatesLoading] = useState(true);
// 	const [noteTemplates, setNoteTemplates] = useState([]);

// 	const getNotesTemplates = () => {
// 		axios
// 			.get(`/note-template`)
// 			.then((result) => {
// 				if (Array.isArray(result.data.data) && result.data.data.length) {
// 					setNoteTemplates(result.data.data);
// 				}
// 			})
// 			.catch(() => {})
// 			.finally(() => {
// 				setNoteTemplatesLoading(false);
// 			});
// 	};

// 	useEffect(() => {
// 		getNotesTemplates();
// 	}, []);

// 	return (
// 		<Row align='bottom' style={{ marginBottom: 10 }}>
// 			<Col sm={12} md={12}>
// 				{fieldLabel}
// 			</Col>
// 			<Col sm={12} md={12}>
// 				<Select
// 					placeholder='Select from Note Templates'
// 					style={{ width: '100%' }}
// 					fieldNames={{ label: 'templateName', value: '_id' }}
// 					loading={isNoteTemplatesLoading}
// 					options={noteTemplates}
// 					onChange={(value, option) => {
// 						onChange(option, fieldName);
// 					}}
// 				/>
// 			</Col>
// 		</Row>
// 	);
// }



import React, { useEffect, useRef, useState } from 'react';
import { Col, Input, Radio, Row, Select } from 'antd';
import axios from '../../utils/axios';
import FilePreviewUploader from '../FilePreviewUploader';
import FAQ from './FAQ';
import Editor from '../Editor';

export default function Details({ Form, getFieldValue, setFieldValue, fileList, setFileList }) {
	const editor = useRef();
	const [isEventTypeLoading, setEventTypeLoading] = useState(true);
	const [eventTypes, setEventTypes] = useState([]);
	const getEventTypes = () => {
		axios
			.get(`/event-type`)
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					setEventTypes(result.data.data);
				}
			})
			.catch(() => {})
			.finally(() => {
				setEventTypeLoading(false);
			});
	};

	const onNoteTemplateChange = (option, field) => {
		const existingData = structuredClone(getFieldValue(field));
		const tempOption = structuredClone(option);
		if (field === 'otherDetails' || field === 'highlights') {
			if (tempOption?.templateRichText?.text) {
				let ops = [];
				if (existingData?.delta) {
					if (typeof existingData?.delta === 'string') {
						existingData.delta = JSON.parse(typeof existingData.delta);
					}
					ops = [...existingData.delta.ops, JSON.parse(tempOption.templateRichText.delta).ops];
				} else {
					ops = JSON.parse(tempOption.templateRichText.delta).ops;
				}
				setFieldValue(field, { delta: { ops } });
			}
		} else if (option.templateText) {
			setFieldValue(field, existingData ? `${existingData}\n${option.templateText}` : option.templateText);
		}
	};
	useEffect(() => {
		getEventTypes();
	}, []);
	return (
		<Row gutter={[16, 0]}>
			<Col sm={24} md={12}>
				<Form.Item
					label='Title'
					name='title'
					rules={[
						{
							required: true,
							message: 'Title is required',
						},
					]}
				>
					<Input placeholder='Kashmir Tour' autoFocus />
				</Form.Item>
			</Col>
			<Col sm={24} md={4}>
				<Form.Item label='Tours/Trek?' name='isTrekOrTour'>
					<Radio.Group>
						<Radio value='Trek'>Trek</Radio>
						<Radio value='Tour'>Tour</Radio>
					</Radio.Group>
				</Form.Item>
			</Col>
			<Col sm={24} md={4}>
				<Form.Item label='Event type' name='eventType'>
					<Select allowClear showArrow mode='multiple' style={{ width: '100%' }} placeholder='Group Tour, Sahyadri Trek' fieldNames={{ label: 'eventType', value: '_id' }} loading={isEventTypeLoading} options={eventTypes} />
				</Form.Item>
			</Col>
			<Col sm={24} md={4}>
				<Form.Item label='Difficulty level' name='difficultyLevel'>
					<Select
						allowClear
						showArrow
						style={{ width: '100%' }}
						placeholder='Easy, Medium'
						options={[
							{
								label: 'Easy',
								value: 'Easy',
							},
							{
								label: 'Medium',
								value: 'Medium',
							},
							{
								label: 'Hard',
								value: 'Hard',
							},
						]}
					/>
				</Form.Item>
			</Col>

			<Col sm={24} md={4}>
				<Form.Item
					label={
						<span>
							Days&nbsp;
							<span style={{ fontSize: '12px', color: '#888' }}>(Total no. of days for tour/trek)</span>
						</span>
					}
					name='days'
				>
					<Input type='number' placeholder='3' min={1} />
				</Form.Item>
			</Col>

			<Col sm={24} md={4}>
				<Form.Item
					label={
						<span>
							Nights&nbsp;
							<span style={{ fontSize: '12px', color: '#888' }}>(Total nights including stay/camp)</span>
						</span>
					}
					name='nights'
				>
					<Input type='number' placeholder='2' min={0} />
				</Form.Item>
			</Col>

			<Col sm={24} md={12}>
				<Form.Item label='Description' name='description'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				{/* <NoteTemplateSelector fieldLabel='Highlights' fieldName='highlights' onChange={onNoteTemplateChange} />
				<Form.Item name='highlights'>
					<Editor ref={editor} Form={Form} />
				</Form.Item> */}
				{/* <Form.Item label='Highlights' name='highlights'>
					<Editor ref={editor} Form={Form} />
				</Form.Item> */}
				<Form.Item label='Highlights' name='highlights'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Includes' fieldName='includes' onChange={onNoteTemplateChange} />
				<Form.Item name='includes'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Excludes' fieldName='excludes' onChange={onNoteTemplateChange} />
				<Form.Item name='excludes'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Other Details' fieldName='otherDetails' onChange={onNoteTemplateChange} />
				<Form.Item name='otherDetails'>
					<Editor ref={editor} Form={Form} />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Cancellation Policy' fieldName='cancellationPolicy' onChange={onNoteTemplateChange} />
				<Form.Item name='cancellationPolicy'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Payment Details' fieldName='paymentDetails' onChange={onNoteTemplateChange} />
				<Form.Item name='paymentDetails'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Things To Carry' fieldName='thingsToCarry' onChange={onNoteTemplateChange} />
				<Form.Item name='thingsToCarry'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Important Point to Note' fieldName='importantPointtoNote' onChange={onNoteTemplateChange} />
				<Form.Item name='importantPointtoNote'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			<Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Disclaimer' fieldName='discclaimer' onChange={onNoteTemplateChange} />
				<Form.Item name='discclaimer'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Write one option per line' />
				</Form.Item>
			</Col>
			
			{/* <Col sm={24} md={12}>
				<NoteTemplateSelector fieldLabel='Payment Details' fieldName='paymentDetails' onChange={onNoteTemplateChange} />
				<Form.Item name='paymentDetails'>
					<Editor ref={editor} Form={Form} />
				</Form.Item>
			</Col> */}
			<Col sm={24} md={12}>
				<Form.Item label='Photos' name='media'>
					<FilePreviewUploader Form={Form} maxItems={10} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
				</Form.Item>
			</Col>
		

			<Col sm={24} md={24}>
				<FAQ Form={Form} />
			</Col>
		</Row>
	);
}

function NoteTemplateSelector({ fieldLabel, fieldName, onChange }) {
	const [isNoteTemplatesLoading, setNoteTemplatesLoading] = useState(true);
	const [noteTemplates, setNoteTemplates] = useState([]);

	const getNotesTemplates = () => {
		axios
			.get(`/note-template`)
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					setNoteTemplates(result.data.data);
				}
			})
			.catch(() => {})
			.finally(() => {
				setNoteTemplatesLoading(false);
			});
	};

	useEffect(() => {
		getNotesTemplates();
	}, []);

	return (
		<Row align='bottom' style={{ marginBottom: 10 }}>
			<Col sm={12} md={12}>
				{fieldLabel}
			</Col>
			<Col sm={12} md={12}>
				<Select
					placeholder='Select from Note Templates'
					style={{ width: '100%' }}
					fieldNames={{ label: 'templateName', value: '_id' }}
					loading={isNoteTemplatesLoading}
					options={noteTemplates}
					onChange={(value, option) => {
						onChange(option, fieldName);
					}}
				/>
			</Col>
		</Row>
	);
}
